import JsonConstrain from "./constraints/JsonConstrain.interface";
import { MaxProducts, MaxProductsMultiplier } from "./constraints";

const allConstrainsArray = [MaxProducts, MaxProductsMultiplier];

class ConstrainCreator {
  static fromJSON(
    JSONConstraints: JsonConstrain[] | null,
  ): (MaxProducts | MaxProductsMultiplier)[] {
    if (!JSONConstraints) {
      return [];
    }
    const constraints: (MaxProducts | MaxProductsMultiplier)[] = [];

    JSONConstraints.forEach((JSONConstraint: JsonConstrain) => {
      const Constraint = allConstrainsArray.find(
        (constraint: typeof MaxProducts | typeof MaxProductsMultiplier) =>
          constraint.Name === JSONConstraint.name,
      );

      if (Constraint) {
        constraints.push(
          new Constraint(
            JSONConstraint.value,
            JSONConstraint.multiplier,
            JSONConstraint.errorMessage,
          ),
        );
      }
    });

    return constraints;
  }
}

export default ConstrainCreator;
